import { useEffect } from 'react';
import { registerHandler, unregisterHandler } from 'event-bus';

const useEventBus = (busId, updateEvents, dependencies = []) => {
  useEffect(() => {
    registerHandler(busId, updateEvents);

    return () => unregisterHandler(busId, updateEvents);
  }, dependencies);
};

export default useEventBus;
